import { SET_ASSET, RESET_ASSETS, UNSET_ASSET, UPDATE_ASSET } from "./types.js";
import { setErrors } from "./error.js";
import { tokenize } from "../helpers/token.js";
import service from "../providers/service.js";

// Delete asset
export function deleteAsset(asset) {
  return dispatch => {
    if (asset.hasOwnProperty('id')) {
      service
        .post(tokenize(`/api/assets/${asset.id}/destroy`))
        .then(response => {
          if (response.data.message === 'asset.success') {
            dispatch(unsetAsset(asset.name));
          }

          if (response.data.errors) {
            dispatch(setErrors(response.data.errors));
          }
        }).catch(err => {
          console.log(err);
        });
    } else {
      // only unset from store
      dispatch(unsetAsset(asset.name));
    }

  }
}

// Update asset
export function updateAsset(asset) {
  return dispatch => {
    if (asset.isLocal) {
      // only unset from store
      dispatch(updateAssetInStore(asset));
    } else {
      service
        .post(tokenize(`/api/assets/${asset.id}`), asset)
        .then(response => {
          if (response.data.message === 'asset.success') {
            dispatch(updateAssetInStore(asset));
          }

          if (response.data.errors) {
            dispatch(setErrors(response.data.errors));
          }
        }).catch(err => {
          console.log(err);
        });

    }

  }
}

// set asset to store
export function setAsset(asset) {
  return {
    type: SET_ASSET,
    asset: asset
  };
}

// unset asset from store
export function unsetAsset(assetName) {
  return {
    type: UNSET_ASSET,
    assetName: assetName
  };
}

export function updateAssetInStore(asset) {
  return {
    type: UPDATE_ASSET,
    asset: asset
  };
}

// reset assets
export function resetAssets() {
  return { type: RESET_ASSETS };
}


// WEBPACK FOOTER //
// ./src/actions/asset.js